import { render, staticRenderFns } from "./QTab.vue?vue&type=template&id=361f004e&scoped=true"
import script from "./QTab.vue?vue&type=script&lang=js"
export * from "./QTab.vue?vue&type=script&lang=js"
import style0 from "./QTab.vue?vue&type=style&index=0&id=361f004e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f004e",
  null
  
)

export default component.exports